<template>
  <center v-if="idat">
    <div class="info7" ref="containerDiv">
      <h1>{{idat.heading}}</h1>
      <img v-bind:src="idat.img" id="mapImage" ref="mapImage">
      <div class="marker-container">
        <div v-for="(mark,i) in idat.markers" class="marker"
             @click="markerClick" v-bind:style="'top:' + mark.pos.x + 'px; left:' + mark.pos.y + 'px;'"
             v-bind:dat-did='"desc-" + i' v-bind:key='"desc-marker-" + i'>
          <font-awesome-icon icon="fa fa-map-pin " size="xs" style="color: white;"></font-awesome-icon>
          <div class="title">{{mark.title}}</div>
        </div>
      </div>
      <div v-for="(mark,i) in idat.markers" class="marker-description" v-bind:id='"desc-" + i' v-bind:key='"desc-desc-" + i'>
        <button onclick="this.parentElement.classList.remove('active')">X</button>
        <div class="dat" v-html="mark.descr"></div>
      </div>
    </div>
  </center>
</template>

<script type="text/javascript">
import { ajaxGet,ajaxPost } from "../../../ajax";
import {apiUrl} from "@/main";
export default{
  data: function(){
    return {
      idat: undefined,
      infoId: undefined
    }
  },
  methods: {
    markerClick(e){
      console.log(e);
      var id = e.srcElement.parentElement.getAttribute("dat-did");
      if(id == null) id = e.srcElement.getAttribute("dat-did");
      document.querySelectorAll(".marker-description").forEach(md=>{
        md.classList.remove("active");
      });
      document.querySelector("#" + id).classList.add("active");
    }
  },
  mounted(){
    this.infoId = this.$router.history.current.params.infoId;
    var assignmentFlag = (this.$router.history.current.query.Assignment === null) ? 'assignments' : 'content';
    ajaxGet(apiUrl()+"/"+assignmentFlag+"/" + this.infoId,
        (dat) => {
          //on success dat is called
          if(dat.component == "map"){
            
            let comp = this;
            this.idat = dat.data;
          setTimeout(function(){
            console.log(comp.$refs.mapImage);

            let imageHeight = comp.$refs.mapImage.clientHeight;
            let imageWidth = comp.$refs.mapImage.clientWidth;
            let windowWidth = comp.$refs.containerDiv.clientWidth;
            let windowHeight = comp.$refs.containerDiv.clientHeight;
            let offset = (windowWidth - imageWidth) / 2;
            let yOffset = (windowHeight - imageHeight) / 2;
            console.log(windowWidth)
            
            console.log(imageWidth)
            console.log(imageHeight)
            for (let i = 0; i  < comp.idat.markers.length; i++){
              comp.idat.markers[i].pos.x = dat.data.markers[i].pos.x ;// /  (495.0 / imageHeight) -53;
              comp.idat.markers[i].pos.y = dat.data.markers[i].pos.y ;//  / (800.0 / imageWidth) -53;
            }
            
          },100);
            
            window.document.title = dat.title;
            this.isAnswered = dat.answers;
            //----------------------------------------------------------
            if(this.$router.history.current.query.Assignment === null && !this.isAnswered){
              ajaxPost(apiUrl() +"/assignments/" + this.infoId, {
                    Data: {
                      seen: Date.now()
                    }
                  },
                  (suc) => {
                    console.log("Posted assignment:", suc);
                  },
                  (err) => {
                    console.log("Error :", err)
                  }, localStorage.token);
            }
            
            //----------------------------------------------------------
          }else{
            //Wrong component type
            console.error("DATA MISMATCH on api call expected 'GALLERY' object, got '" + dat.component.toUpperCase() + "' object.");
          }
        },(err) => {
          //There was some error
          console.log(err);
        }, localStorage.token);
  }
}
</script>
<style scoped>
.marker-container{
  position: absolute;
  width: 1200px;
  height: 750px;
}
.marker{
  position: absolute;
  /*background: #9e2114dd;*/
  border-radius: 10px;
  cursor: pointer;
}
.marker .title{
  color: white;
}
.marker-description{
  position: absolute;
  bottom: 150px;
  max-width: 800px;
  border: 1px solid black;
  background: #fffd;
  border-radius: 10px;
  display: none;
  padding: 10px 10px 0px 10px;
}
.marker-description.active{
  display: block;
}
.marker-description .dat{
  text-align: center;
}
.marker-description button{
  position: absolute;
  top: -10px;
  right: 2px;
  background: #720000dd;
  color: white;
  font-weight: bold;
  border-radius: 50%;
}
h1{
  font-size: 1.5em;
  color: white;
  position: absolute;
  background: #9e211499;
  padding: 2px 30px;
  border-radius: 10px;
  max-width: 800px;
}
.info7{
  position: relative;
  top: 75px;
  max-height: calc(100vh - 75px);
  height: calc(100vh - 75px);
  /*width: 100%;
  height: 1200px;
  max-width: 100%;
  max-height: 1200px;*/
  overflow: auto;
  display:flex;
  align-items: center;
  flex-direction: column;
  background: #000000; /* Old browsers */
  background: -moz-linear-gradient(45deg, #000000 0%, #45484d 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(45deg, #000000 0%,#45484d 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(45deg, #000000 0%,#45484d 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#45484d',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
}

img{
  /*width: 1200px;
  max-height: 100%;
  */
  /*  width: 1400px;
   height: 900px;
    */
  width: 1314px;
   height: 812px;

}
/*
.info6 > img{
  width: 800px;
  height: 100%;
  object-fit: contain;
}
.markers{
  position: absolute;
  top : 100;
  left: 100;
}*/
</style>